
import { defineComponent } from 'vue';
import {
  IDanhMucVatTuResponseBase,
  ITaiKhoanKeToanResponse,
} from '@/core/interfaces/ApiResponses';
import DanhMucVatTuService from '@/core/services/DanhMucVatTu.service';
import { swalErrNotification } from '@/core/helpers/utils';
import { generateTablePdf } from '@/core/helpers/generate-table-pdf';
import PdfViewerPage from '@/components/shared/pdf-viewer/PdfViewerPage.vue';
import { PDF_GENERATE_TABLE_DEFAULTS } from '@/components/shared/pdf-viewer/pdf-content.config';
import { pickDonViPdfExtra } from '@/components/shared/pdf-viewer/pdf-document-header';

function formatTkKetoan(tk?: ITaiKhoanKeToanResponse | null): string {
  if (!tk?.matk && !tk?.mact && !tk?.tentk) {
    return '-';
  }

  return `${tk?.matk || '-'} / ${tk?.mact || '-'} / ${tk?.tentk || '-'}`;
}

const DANH_MUC_VAT_TU_PDF_COLUMNS = [
  { header: 'STT', width: 22, align: 'center' as const },
  { header: 'Tên', width: 90, align: 'left' as const },
  { header: 'Mã nhóm', width: 35, align: 'left' as const },
  { header: 'TK Kế toán', width: 55, align: 'left' as const },
  { header: 'Ghi chú', width: 71, align: 'left' as const },
];

export default defineComponent({
  name: 'DanhMucVatTuListViewer',

  components: { PdfViewerPage },

  data() {
    return {
      items: [] as IDanhMucVatTuResponseBase[],
      searchTerm: '',
      pdfSource: null as string | null,
      isGenerating: false,
      tenDonVi: '',
      tenDonViCha: '',
    };
  },

  computed: {
    pdfFileName(): string {
      return 'danh-sach-nhom-vat-tu.pdf';
    },
  },

  methods: {
    async loadAndGenerate() {
      const queryS = this.$route.query.s;
      this.searchTerm = typeof queryS === 'string' ? queryS : '';

      try {
        this.isGenerating = true;
        this.pdfSource = null;

        const listResult = await DanhMucVatTuService.listAll(this.searchTerm);
        this.items = listResult.items;
        const { tenDonVi, tenDonViCha } = pickDonViPdfExtra(listResult.extra);
        this.tenDonVi = tenDonVi;
        this.tenDonViCha = tenDonViCha;
        this.pdfSource = await this.generatePdf();
      } catch (e) {
        swalErrNotification(e, 'Có lỗi khi tải danh sách nhóm vật tư');
      } finally {
        this.isGenerating = false;
      }
    },

    async generatePdf(): Promise<string> {
      const rows = this.items.map((item, index) => [
        String(index + 1),
        item.ten_danh_muc ?? '',
        item.ma_danh_muc ?? '',
        formatTkKetoan(item.tk_ketoan),
        item.mo_ta || '-',
      ]);

      return generateTablePdf({
        ...PDF_GENERATE_TABLE_DEFAULTS,
        title: 'DANH SÁCH NHÓM VẬT TƯ',
        subtitle: this.searchTerm ? `Từ khóa: ${this.searchTerm}` : undefined,
        columns: DANH_MUC_VAT_TU_PDF_COLUMNS,
        rows,
        documentHeader: {
          tenDonVi: this.tenDonVi,
          tenDonViCha: this.tenDonViCha,
          variant: 'masterList',
        },
      });
    },
  },

  mounted() {
    this.loadAndGenerate();
  },
});
